import { render, staticRenderFns } from "./editChetouNew.vue?vue&type=template&id=6fa5e209&scoped=true&"
import script from "./editChetouNew.vue?vue&type=script&lang=js&"
export * from "./editChetouNew.vue?vue&type=script&lang=js&"
import style0 from "./editChetouNew.vue?vue&type=style&index=0&id=6fa5e209&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5e209",
  null
  
)

export default component.exports